<form class="mapping-form" [formGroup]="form">
  <app-form>
    <app-row>
      <app-field [label]="'Идентификатор'">
        <input
          pInputText
          type="text"
          formControlName="value"
          placeholder="Введите значение"
          [class.loading]="loading"
        />
      </app-field>

      <app-field [label]="'Отображаемое значение'">
        <input
          pInputText
          type="text"
          formControlName="display"
          placeholder="Введите отображаемое значение"
          [class.loading]="loading"
        />
      </app-field>
    </app-row>
  </app-form>
</form>
